import { PriorityLowIcon } from './PriorityLowIcon';

/**
 * author: Google
 * id DFC698A7-3040-48F4-A341-C1E667A4FE22
 * name priority-low
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/priority-low.svg
 * tags
 */
export const LowPriorityIcon = PriorityLowIcon;
export default LowPriorityIcon